var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('amplify-sign-out',{attrs:{"signOutConfig":_vm.signOutConfig}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }